import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ModalContextType {
  isOpen: boolean;
  modalType: string | null;
  modalProps: any;
  openModal: (type: string, props?: any) => void;
  closeModal: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export function ModalProvider({ children }: { children: ReactNode }) {
  console.log('🟢 ModalProvider initialized');
  const [isOpen, setIsOpen] = useState(false);
  const [modalType, setModalType] = useState<string | null>(null);
  const [modalProps, setModalProps] = useState<any>({});

  const openModal = (type: string, props: any = {}) => {
    console.log('ModalContext.openModal called:', { type, props });
    setModalType(type);
    setModalProps(props);
    setIsOpen(true);
    console.log('Modal state after opening:', { isOpen: true, modalType: type });
  };

  const closeModal = () => {
    setIsOpen(false);
    setModalType(null);
    setModalProps({});
  };

  return (
    <ModalContext.Provider value={{
      isOpen,
      modalType,
      modalProps,
      openModal,
      closeModal
    }}>
      {children}
    </ModalContext.Provider>
  );
}

export function useModal() {
  console.log('🟡 useModal hook called');
  const context = useContext(ModalContext);
  if (context === undefined) {
    console.error('🔴 useModal ERROR: not within ModalProvider');
    throw new Error('useModal must be used within a ModalProvider');
  }
  console.log('🟡 useModal returning context:', context);
  return context;
}
